<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <v-card>
            <v-card-text primary-text class="title font-weight-bold">
                Check Logs for {{captain.first_name}}
            </v-card-text>
            <data-table :url="api.ACTIONS.CHECK_LOGS"
                        :initial-url-search-params="params"
                        disable-search
                        :enable-add="false"
                        :enable-delete="false"
                        :enable-edit="false"
                        :fields-hidden-main="['captain_id','created_at','updated_at']"
                        :titles="titles"
                        :row-call-back="rowCallBack"
                        :formatter="formatter"
                        descending
                        :actions-extra-main="actions"/>
        </v-card>
        <v-dialog v-model="dialog" scrollable width="60%">
            <v-card>
                <v-card-title>
                    Summary
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="checkLogDetails" :search="search">
                    <template v-slot:items="props">
                        <td class="text-xs-left">{{ props.item.ride_id }}</td>
                        <td class="text-xs-left">{{ props.item.type }}</td>
                        <td class="text-xs-left">{{ props.item.kilometer }}</td>
                        <td class="text-xs-left">{{ moment(props.item.from_datetime).format('hh:mm A - DD MMM YYYY') }}</td>
                        <td class="text-xs-left">{{ moment(props.item.to_datetime).format('hh:mm A - DD MMM YYYY') }}</td>
                    </template>
                    <v-alert v-slot:no-results :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </v-data-table>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        components: {LoadingComponent, DataTable},
        props: ['captain'],
        name: "check-log-component",
        data() {
            return {
                loading: false,
                dialog: false,
                details_url: '',
                search: null,
                headers: [
                    {text: 'ID', value: 'ride_id', sortable: false},
                    {text: 'Type', value: 'type', sortable: false},
                    {text: 'Kilometer', value: 'kilometer', sortable: false},
                    {text: 'From', value: 'from_datetime', sortable: false},
                    {text: 'To', value: 'to_datetime', sortable: false},
                ],
                checkLogDetails: []
            }
        },
        methods: {
            rowCallBack(item) {
                if (item.to_datetime == null)
                    return ['active-check-log'];
            }
        },
        computed: {
            actions() {
                return {
                    prices: {
                        title: "Details",
                        action: ({id}) => {
                            this.loading = true;
                            this.axios.get(`check_log/${id}/details`)
                                .then(res => {
                                    this.checkLogDetails = res.data.data;
                                    this.dialog = true;
                                })
                                .catch(err => console.log(err.message))
                                .finally(() => this.loading = false);
                        }
                    }
                }
            },
            titles() {
                return {
                    id: '#',
                    from_datetime: "From",
                    to_datetime: "To",
                    kilometrage: "Kilometers"
                }
            },
            params() {
                const params = new URLSearchParams();
                params.append('captain_id', this.captain.id);
                return params;
            },
            formatter() {
                return {
                    from_datetime(val) {
                        return moment(val).format("YYYY-MM-DD HH:mm:ss");
                    },
                    to_datetime(val) {
                        if (val === null)
                            return "Still Online";
                        else
                            return moment(val).format("YYYY-MM-DD HH:mm:ss");
                    },
                    kilometrage(val) {
                        return val.toString();
                    }
                }
            }
        }
    }
</script>

<style scoped>
    div >>> .active-check-log {
        background: lightgreen;
    }
</style>